import { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import rawProjects from "../data/projects";
import MosaVideo from "../components/MosaVideo";

// 🔁 Mélange les projets une fois
function shuffle(array) {
  const result = [...array];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

// 🏷 Génère un ID basé sur le dossier dans l’image (ex: "cours" depuis "/img/cours/cover.png")
function generateIdFromImagePath(imagePath) {
  const match = imagePath.match(/\/img\/([^/]+)\//);
  return match ? match[1] : "";
}

function Projects() {
  const [selectedTag, setSelectedTag] = useState("all");

  // 🔧 Ajout d'un ID à chaque projet à partir de son image
  const projectsWithId = useMemo(() => {
    return shuffle(
      rawProjects.map((proj) => ({
        ...proj,
        id: generateIdFromImagePath(proj.image),
      }))
    );
  }, []);

  // 🧼 Liste des tags uniques
  const allTags = [
    ...new Set(projectsWithId.flatMap((proj) => proj.tags || [])),
  ];

  // 🔍 Filtrage par tag
  const filteredProjects =
    selectedTag === "all"
      ? projectsWithId
      : projectsWithId.filter((proj) => proj.tags?.includes(selectedTag));

  return (
    <section id="projects" className="">
      <div className="aboveNoise">
        <MosaVideo />

        <div className="container">
          <h2
            className="text-center passion-one-black titreProjet"
            id="lesprojets"
          >
            Motion, Websites, <br /> logos & more.
          </h2>

          {/* 🎛 Filtres par tag */}
          <div className="text-center mb-4 btnFilter">
            <button
              className={`btn me-2 mb-2 ${
                selectedTag === "all" ? "btn-dark" : "btn-outline-dark"
              }`}
              onClick={() => setSelectedTag("all")}
            >
              Tous
            </button>
            {allTags.map((tag) => (
              <button
                key={tag}
                className={`btn me-2 mb-2 ${
                  selectedTag === tag ? "btn-dark" : "btn-outline-dark"
                }`}
                onClick={() => setSelectedTag(tag)}
              >
                {tag}
              </button>
            ))}
          </div>

          {/* 🎨 Cartes projets */}
          <div className="row">
            {filteredProjects.map((proj) => (
              <div key={proj.id} className="col-md-4 mb-4">
                <Link
                  to={`/projects/${proj.id}`}
                  className="text-decoration-none text-dark"
                >
                  <div className="card h-100">
                    <img
                      src={`${process.env.PUBLIC_URL}${proj.image}`}
                      className="card-img-top card-img-fixed"
                      alt={proj.title}
                    />
                    <div className="card-body">
                      <h5 className="card-title">{proj.title}</h5>
                      <div>
                        {proj.tags?.map((tag, i) => (
                          <span key={i} className="badge bg-secondary me-1">
                            {tag}
                          </span>
                        ))}
                      </div>
                      <p className="cardArrow">→</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;
